import { SerializableObject } from '../../core';


/**
 * Holds json schema information for various properties of the Report Module Settings object
 */
export class ReportModuleSettingsJsonSchema extends SerializableObject {
  /**
   * Holds the JSON Schema for the ReportDefinition property.
   */
  public reportDefinition: Object;

  /**
   * Holds the JSON Schema for the DashboardSets property.
   */
  public dashboardSets: Object;

  protected coercePropertyType(property: string, value: any): any {
    let returnValue: any = super.coercePropertyType(property, value);

    switch (property) {
      case 'reportDefinition':
      case 'dashboardSets':
        return JSON.parse(value);

      default:
        return returnValue;
    }
  }
}
